// extracted by mini-css-extract-plugin
export default {"tooltip":"businessProvince_tooltip__K8Vhp","tooltipRow":"businessProvince_tooltipRow__wmmgO"};